import * as Bluebird from 'bluebird';

type PromiseGenerator<T> = () => Promise<T> | Bluebird<T>;

interface QueuedPromise<T> {
  promiseGenerator: PromiseGenerator<T>;
  resolve: (value: T) => void;
  reject: (reason?: any) => void;
}

export class PromiseQueue<T> {
  private pendingCount = 0;
  private queue: QueuedPromise<T>[] = [];

  constructor(private maxConcurrent: number = 10) { }

  add(promiseGenerator: PromiseGenerator<T>): Promise<T> | Bluebird<T> {
    return new Promise((resolve, reject) => {
      this.queue.push({ promiseGenerator, resolve, reject });

      this.dequeue();
    });
  }

  private async dequeue(): Promise<void> {
    if (this.pendingCount >= this.maxConcurrent) {
      return;
    }

    const nextInLine = this.queue.shift();

    if (!nextInLine) {
      return;
    }

    try {
      this.pendingCount++;

      const value = await nextInLine.promiseGenerator();

      this.pendingCount--;
      nextInLine.resolve(value);
      this.dequeue();
    } catch (err) {
      this.pendingCount--;
      nextInLine.reject(err);
      this.dequeue();
    }
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/common/util/PromiseQueue.ts